// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 30rem;
  margin-left: auto;
  margin-right: auto;
}

h1 {
  margin: 0%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/company-stand/ad/ad.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":["img {\r\n  max-width: 30rem;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\nh1 {\r\n  margin: 0%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
